<template>
    <!--
        Компонент інфо-блоків - читабельний лаконічний дизайн
    -->

    <div class="row g-2">
        <div
            :class="`col-xl-${
                form.length == '2'
                ? form.length + 4 : form.length == '3'
                ? form.length + 1 : form.length == '4'
                ? (form.length-1) : form.length == '5'
                ? form.length - 2 : '6'} col-sm-12`
            "
            v-for="(item, index) in form"
            :key="item"
        >
            <div
                :class="['border', 'rounded', 'p-2', 'h-100', 'info-block', { 'copy-block': item.copy }, getPaymentStatusClass(item)]"
                :style="`border-left: 3px solid var(--vz-${item.color || 'secondary'}) !important;`"
                :id="`infoStep`+index"
                @click="item.copy ? copyData(item) : null"
            >
                <p class="text-uppercase text-muted mb-1 fs-11">{{ item.title }}</p>
                <p :class="['fs-15', 'fw-semibold', 'mb-0', getPaymentTextClass(item)]">{{ item.value }}</p>
                <p v-if="item.lacks" class="fs-12 text-danger mb-0 mt-1">
                    <span class="text-muted fs-10">Не вистачає:</span> {{ item.lacks }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {copy} from '@/usabilityScripts/copy.js'

export default{
    props: ['obj'],
    data(){
        return{
            form: "" // Змінна для зберігання даних інформаційних блоків
        }
    },
    created(){
        // Ініціалізація змінної даних інформаційних блоків з отриманими даними
        this.form = this.obj
    },
    methods: {
        copyData(item){
            let text = item.title + ': ' + item.value
            if(item.lacks) {
                text += ' (Не вистачає: ' + item.lacks + ')'
            }
            if(copy(text)) {
                this.$toast.success(this.$t('Copied'))
            } else {
                this.$toast.error(this.$t('error'))
            }
        },
        // Перевірка чи значення є датою у форматі YYYY-MM-DD
        isDateValue(value) {
            if (!value || typeof value !== 'string') return false
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/
            return dateRegex.test(value)
        },
        // Перевірка статусу оплати (чи дата в майбутньому)
        isPaid(dateStr) {
            if (!this.isDateValue(dateStr)) return null
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            const paymentDate = new Date(dateStr)
            return paymentDate >= today
        },
        // Отримання класу для блоку на основі статусу оплати
        getPaymentStatusClass(item) {
            // Перевіряємо тільки блоки з датою (Сплачено до, PaidUpTo)
            if (!this.isDateValue(item.value)) return ''
            const paid = this.isPaid(item.value)
            if (paid === null) return ''
            return paid ? 'payment-paid' : 'payment-expired'
        },
        // Отримання класу тексту для статусу оплати
        getPaymentTextClass(item) {
            if (!this.isDateValue(item.value)) return ''
            const paid = this.isPaid(item.value)
            if (paid === null) return ''
            return paid ? 'text-success' : 'text-danger'
        }
    }
}
</script>

<style scoped>
.info-block {
    background-color: var(--vz-card-bg, #fff);
    transition: all 0.2s;
}
.copy-block {
    cursor: pointer;
}
.copy-block:hover {
    background-color: var(--vz-secondary-bg, rgba(0,0,0,0.05)) !important;
    transform: translateY(-1px);
}
/* Стилі для статусу оплати */
.payment-paid {
    background-color: rgba(var(--vz-success-rgb), 0.1) !important;
    border-color: var(--vz-success) !important;
}
.payment-expired {
    background-color: rgba(var(--vz-danger-rgb), 0.1) !important;
    border-color: var(--vz-danger) !important;
}
</style>